export default __webpack_public_path__ + "static/media/sports.4a149aa0.svg";